import { Fragment } from 'react';
import { formatMoney_2, NumberToNepaliNum } from '../../../../helpers/DateFormat';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { useLanguage } from '../../../../context/LanguageProvider';
import { NepNowDateFormat } from '../../../../constants/DateFormat';
import AppURL from '../../../../constants/AppURL';

const PrintDayBookListView = ({ onDayBookReport }: any) => {
  const { SOFTWARE_ORG, ACCOUNT_RPT_DATE } = useSelector((state: RootState) => state.software);
  const org_details = SOFTWARE_ORG?.org;
  const date_report = ACCOUNT_RPT_DATE.acc_rpt;
  const { language } = useLanguage();
  const DateNow = NepNowDateFormat();
  const totals = {
    tariff: 0,
    fine: 0,
    pipe: 0,
    advance: 0,
    nameExchange: 0,
    connection: 0,
    renew: 0,
    meter: 0,
    bibidh: 0,
    other: 0,
    totalAmount: 0,
    discount: 0,
    netAmount: 0,
  };

  if (Array.isArray(onDayBookReport?.results)) {
    onDayBookReport.results.forEach((item: any) => {
      const tariff = item?.incomereveiced || 0;
      const fine = item?.fineamount || 0;
      const pipe = item?.pipeandfitting || 0;
      const advance = item?.advanceamountcollect || 0;
      const nameExchange = item?.namsarisulka || 0;
      const connection = item?.dharajadanshulka || 0;
      const renew = item?.renewalcharge || 0;
      const meter = item?.metercharge || 0;
      const bibidh = item?.bibidh || 0;
      const other = item?.anya || 0;
      const discount = item?.discountamount || 0;

      const total = tariff + fine + pipe + advance + nameExchange + connection + renew + meter + bibidh + other;
      const net = total - discount;

      totals.tariff += tariff;
      totals.fine += fine;
      totals.pipe += pipe;
      totals.advance += advance;
      totals.nameExchange += nameExchange;
      totals.connection += connection;
      totals.renew += renew;
      totals.meter += meter;
      totals.bibidh += bibidh;
      totals.other += other;
      totals.totalAmount += total;
      totals.discount += discount;
      totals.netAmount += net;
    });
  }
  return (
    <Fragment>
      <style>
        {`@media print {
            @page {
            size: A4 landscape;
            page-break-before: always;
            margin: 0.2in; 
            border: 1px solid black;
         }
        }`}
      </style>
      <div className='bg-white h-screen'>
        <div className="relative border border-gray-300 p-0.5">
          <table className="w-full text-sm text-left rtl:text-right text-black">
            <tbody>
              <tr>
                <td className={`w-[25%] text-[12px] text-black whitespace-nowrap ${language === "Eng" ? "font-public-sans" : "font-nepali"}`} >
                  {language === "Eng" ? "S. Code: " : "एस. कोड:"}:  {language === "Eng" ? org_details?.org_reg : NumberToNepaliNum(org_details?.org_reg || "")}
                </td>
                <td className="w-[25%]">
                </td>
                <td className="w-[25%]">
                </td>
                <td align='right' className={`w-[25%] text-[12px] text-black whitespace-nowrap ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Phone: " : "फोन नम्बर:"}  {language === "Eng" ? org_details?.org_phone : NumberToNepaliNum(org_details?.org_phone || 0)}
                </td>
              </tr>
              <tr >
                <td rowSpan={4} className="w-[25%] font-medium text-black whitespace-nowrap dark:text-white">
                  <img width={60} height={60} src={AppURL.BaseURL + org_details?.logo} alt="" />
                </td>
                <td align='center' colSpan={2} className={`w-[25%] text-black font-bold text-[18px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? org_details?.org_name : org_details?.org_name_nep}
                </td>
                <td className="w-[25%]">
                </td>
              </tr>
              <tr >
                <td align='center' colSpan={2} className={`w-[25%] text-black font-normal text-[12px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? org_details?.org_add : org_details?.org_add_nep}
                </td>
                <td align='right' className={`w-[25%] text-[11px] text-black font-normal ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Date: " : "मिति: "} {language === "Eng" ? DateNow : NumberToNepaliNum(DateNow)}
                </td>
              </tr>
              <tr >
                <td align='center' colSpan={2} className={`w-[25%] underline text-black font-bold text-[15px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Day Book Report" : "दैनिक आम्दानी रिपोर्ट"}
                </td>
                <td className="w-[25%]">
                </td>
              </tr>
              <tr>
                <td align='center' colSpan={2} className={`w-[25%] text-black font-light text-[11px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Date: " : "कारोवार मिति: "}
                  {date_report?.date_from}
                </td>
                <td align='right' className={`w-[25%] text-[11px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Voucher No.:........" : "भौचर नम्बर:........."}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className={`relative`}>
          <table className="text-sm text-left rtl:text-right text-sky-900 whitespace-nowrap scroll-x-auto dark:text-slate-400 rounded w-full">
            <thead className="text-[12px] text-gray700 bg-slate-100 dark:bg-sky-950 capitalize border-b dark:bg-slate900 dark:text-slate-400 font-public-sans">
              <tr>
                <th scope="col" rowSpan={2} align='center' className={`px-2 border border-slate-300 dark:border-sky-800 w-10 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "S.N." : "स.नं."}
                </th>
                <th scope="col" rowSpan={2} align='center' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Member Name" : "सदस्यको नाम"}
                </th>
                <th scope="col" rowSpan={2} align='center' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Receipt No." : "रसिद नं."}
                </th>

                <th scope="col" colSpan={2} align='center' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Mahasul" : "महसुल"}
                </th>
                <th scope="col" colSpan={8} align='center' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Other Income" : "अन्य आम्दानी"}
                </th>
                <th scope="col" rowSpan={2} align='center' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Total" : "जम्मा"}
                </th>
                <th scope="col" rowSpan={2} align='center' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Discount" : "छुट"}
                </th>
                <th scope="col" rowSpan={2} align='center' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Net Amount" : "कुल रकम"}
                </th>
              </tr>
              <tr>
                <th scope="col" align='center' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Mahasul" : "महसुल"}
                </th>
                <th scope="col" align='center' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Fine" : "जरिवाना"}
                </th>
                <th scope="col" align='center' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Pipe & Fitting" : "पाइप र फिटिंग"}
                </th>
                <th scope="col" align='center' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Advance" : "धरौटी"}
                </th>
                <th scope="col" align='center' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Name Exchange" : "नामसारी"}
                </th>
                <th scope="col" align='center' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Jadan" : "जडान"}
                </th>
                <th scope="col" align='center' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Renew" : "नवीकरण"}
                </th>
                <th scope="col" align='center' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Meter" : "मिटर"}
                </th>
                <th scope="col" align='center' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Bibidth" : "बिबिध"}
                </th>
                <th scope="col" align='center' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Other" : "अन्य"}
                </th>
              </tr>
            </thead>
            <tbody className='text-slate-800'>
              {Array.isArray(onDayBookReport?.results) &&
                onDayBookReport?.results?.map((item: any, index: number) => {

                  const totalAmount =
                    (item?.incomereveiced || 0) +
                    (item?.fineamount || 0) +
                    (item?.pipeandfitting || 0) +
                    (item?.advanceamountcollect || 0) +
                    (item?.namsarisulka || 0) +
                    (item?.dharajadanshulka || 0) +
                    (item?.renewalcharge || 0) +
                    (item?.metercharge || 0) +
                    (item?.bibidh || 0) +
                    (item?.anya || 0);
                  const netAmount = totalAmount - (item?.discountamount || 0);
                  return (
                    <tr key={index} className="odd:bg-white hover:bg-slate-100 text-[12px] text-gray-800 dark:text-gray-400 odd:dark:bg-sky-900 even:bg-slate-50 even:dark:bg-sky-800 border-b font-public-sans dark:border-gray-700">
                      <td align='center' className={`px-2 border border-gray-300 font-medium dark:border-sky-800 capitalize ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                        {index + 1}.
                      </td>
                      <td align='left' className={`px-2 border border-gray-300 font-medium dark:border-sky-800 capitalize ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                        {`${language === "Eng" ? item?.memname : item?.name_nep}`}
                      </td>
                      <td align='center' className={`px-2 font-medium py-0.5 border border-gray-300 dark:border-sky-800 capitalize text-[11px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                        {item.billingno}
                      </td>
                      <td align='right' className={`px-2 border border-gray-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                        {formatMoney_2(item?.incomereveiced || 0)}
                      </td>
                      <td align='right' className={`px-2 border border-gray-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                        {formatMoney_2(item?.fineamount || 0)}
                      </td>
                      <td align='right' className={`px-2 border border-gray-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                        {formatMoney_2(item?.pipeandfitting || 0)}
                      </td>
                      <td align='right' className={`px-2 border border-gray-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                        {formatMoney_2(item?.advanceamountcollect || 0)}
                      </td>
                      <td align='right' className={`px-2 border border-gray-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                        {formatMoney_2(item?.namsarisulka || 0)}
                      </td>
                      <td align='right' className={`px-2 border border-gray-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                        {formatMoney_2(item?.dharajadanshulka || 0)}
                      </td>
                      <td align='right' className={`px-2 border border-gray-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                        {formatMoney_2(item?.renewalcharge || 0)}
                      </td>
                      <td align='right' className={`px-2 border border-gray-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                        {formatMoney_2(item?.metercharge || 0)}
                      </td>
                      <td align='right' className={`px-2 border border-gray-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                        {formatMoney_2(item?.bibidh || 0)}
                      </td>
                      <td align='right' className={`px-2 border border-gray-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                        {formatMoney_2(item?.anya || 0)}
                      </td>
                      <td align='right' className={`px-2 border border-gray-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                        {formatMoney_2(totalAmount || 0)}
                      </td>
                      <td align='right' className={`px-2 border border-gray-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                        {formatMoney_2(item?.discountamount || 0)}
                      </td>
                      <td align='right' className={`px-2 border border-gray-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                        {formatMoney_2(netAmount || 0)}
                      </td>
                    </tr>
                  )
                })
              }

              <tr className="font-semibold text-[12px] bg-slate-200 text-sky-900 dark:bg-sky-950 dark:text-slate-100">
                <td colSpan={3} align='center' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {`${language === "Eng" ? "Total" : "कुल"}`}
                </td>
                <td align='right' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {formatMoney_2(totals.tariff)}
                </td>
                <td align='right' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {formatMoney_2(totals.fine)}
                </td>
                <td align='right' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {formatMoney_2(totals.pipe)}
                </td>
                <td align='right' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {formatMoney_2(totals.advance)}
                </td>
                <td align='right' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {formatMoney_2(totals.nameExchange)}
                </td>
                <td align='right' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {formatMoney_2(totals.connection)}
                </td>
                <td align='right' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {formatMoney_2(totals.renew)}
                </td>
                <td align='right' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {formatMoney_2(totals.meter)}
                </td>
                <td align='right' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {formatMoney_2(totals.bibidh)}
                </td>
                <td align='right' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {formatMoney_2(totals.other)}
                </td>
                <td align='right' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {formatMoney_2(totals.totalAmount)}
                </td>
                <td align='right' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {formatMoney_2(totals.discount)}
                </td>
                <td align='right' className={`px-2 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {formatMoney_2(totals.netAmount)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
      </div >
    </Fragment>

  )
}

export default PrintDayBookListView


